var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collect-del" }, [
    _vm._m(0),
    _c("div", { staticClass: "dialog-footer" }, [
      _c("input", {
        staticClass: "btn",
        attrs: { type: "button", value: "取消" },
        on: {
          click: function($event) {
            return _vm.cancle()
          }
        }
      }),
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { type: "button", value: "确认" },
        on: {
          click: function($event) {
            return _vm.commit()
          }
        }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dialog-body del-body" }, [
      _c("img", {
        attrs: { src: require("../../assets/system/tips.png"), alt: "" }
      }),
      _c("div", { staticClass: "del-cont" }, [
        _c("div", { staticClass: "tips1" }, [
          _vm._v("你确定要删除这个收藏夹吗？")
        ]),
        _c("div", { staticClass: "tips2" }, [
          _vm._v("删除文件夹后，里面收藏的内容也一并删除")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }